import React from 'react';
import ReactDOM from 'react-dom';
import {LexemePageContent, getLexemeProperties, getDictionaryProperties} from './../../lexeme/page/LexemePage';
import {LexemeEditingLevel, LexemePageInfos, LexemeUtilities} from './../../lexeme/page/editor/LexemeHelper';
import {Grid, Row, Col, Button, MenuItem, Dropdown, DropdownButton, ButtonToolbar} from 'react-bootstrap';
import Dict from 'dict-lib';
import {EntryTypeahead, SCRadiobutton, SCSubmitButton} from './../components';
import './LexemeNavigator.css';
import LexemePage from "./../../lexeme/page/LexemePage";
import stylesLexemeNavigator from './../../_css/dictionary/lexemeNavigator.module.css';
import BUtils from './../../utilities/BaseUtilities';
import {LexemePageContext} from "../../lexeme/page/LexemePageContext";
import {LexemeTitle} from "../../lexeme/page/parts/01_Title/LexemeTitle";
import stylesScNavbar from "../navbar/ScNavbar.module.css";
import ReactTooltip from "react-tooltip";
import {AdministrationUtilities} from "../../administration/AdministrationHelper";
import {userService} from "../../_redux/authentication/services/user.services";

export class LexemeNavigator extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            rootEntryId: "",
            languageId: this.props.languageId,
            dictionaryType: "",
            transLangs: [],
            searchOn: {create: false, homographic: false, text: ''}
        };

        this.container = typeof this.props.container !== 'undefined' ? this.props.container : 'lexeme-navigator-page-container-' + this.props.pageStatus;

        this._setRootEntryId = this._setRootEntryId.bind(this);
        this._handleOnFocus = this._handleOnFocus.bind(this);
        this._handleRadioTradChange = this._handleRadioTradChange.bind(this);
        this._handleCreate = this._handleCreate.bind(this);
    }

    componentWillMount() {
        const status = this.props.pageStatus;
        if (status === LexemeEditingLevel.TRANSLATION_SELECTOR || status === LexemeEditingLevel.EXTERNAL_DICTIONARY_SELECTOR || status === LexemeEditingLevel.READ_ONLY_CREATE) {
            var langs = status === LexemeEditingLevel.TRANSLATION_SELECTOR ? this.props.context.oppositeLanguages : Dict.getVarious("root_languages");
            this._resetNavigatoreChooseLangs(langs);
            if (this.props.context.pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE) {
                const externalApi = {
                    host: this.props.context.host, /*AdministrationUtilities.getAlignmentDictionaryHost()*/
                    name: 'translate'
                };
                externalApi.status = 'OK';
                this.setState({externalApi});
            }

        } else if (status === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE) {
            var languageCode = this.props.context.languageCode;
            var externalApi = this.props.context.externalApi;
            var textToAdd = this.props.textToAdd;
            var navigatorChooseLangs = [];
            this.setState({navigatorChooseLangs});
            /*languageCode = 'LLD-BAD';*/
            Dict.call('/service/getExternalReadOnlyCreateData/' + languageCode + '/', undefined, externalApi.host).then((result) => {
                if (result.result === 'OK') {
                    externalApi.status = 'OK';
                    this.setState({
                        languageId: result.languageId,
                        externalApi,
                        textToAdd
                    });
                } else {
                    externalApi.status = 'error';
                    externalApi.message = result.result;
                    this.setState({
                        externalApi
                    })
                }
            });

        } else {
            var languageId = this.props.languageId;
            if (typeof languageId === 'undefined')
                languageId = getLexemeProperties('language_id');

            var navigatorChooseLangs = [];
            var langItem = AdministrationUtilities.getLangItemById(languageId);
            this._pushNavigatorChooseLang(navigatorChooseLangs, langItem, false);

            var dictionaryType = typeof this.props.useInGlobalDictionary !== 'undefined' && this.props.useInGlobalDictionary ? 'TYPE_1_IN' : getDictionaryProperties('type');

            this.setState({languageId, dictionaryType, navigatorChooseLangs});
        }
    }

    _resetNavigatoreChooseLangs(langs) {
        const isTranslator = this.props.pageStatus === LexemeEditingLevel.TRANSLATION_SELECTOR;
        var navigatorChooseLangs = [];
        var languageId = '';
        var searchOn = this.state.searchOn;
        if (!isTranslator) {
            languageId = langs.find((item) => {
                return item.code === this.props.context.dictProperties.language_code;
            }).id;
        } else {
            languageId = langs[0].id;
            if (LexemeUtilities.foundExternalCreateEnvironment()) {
                var textToTranslate = '';
                var fromAttribute = document.getElementsByClassName(stylesLexemeNavigator['container-lexeme-navigator'])[0].getAttribute('textToTranslate');
                if (typeof fromAttribute !== 'undefined')
                    textToTranslate = fromAttribute;
            }

            searchOn.text = textToTranslate;
        }

        for (var key in langs) {
            this._pushNavigatorChooseLang(navigatorChooseLangs, langs[key], isTranslator);
        }

        this.setState({navigatorChooseLangs, languageId, searchOn});
    }

    _pushNavigatorChooseLang(navigatorChooseLangs, lang, isTranslator) {
        navigatorChooseLangs.push({
            code: lang.id,
            label: isTranslator ? (Dict.t("TRANSLATIONS") + " (" + lang.description + ")") : lang.code,
            variant: lang.id,
            permission: {
                isAllowed: true,
                msg: ''
            }
        });
    }

    _handleRadioTradChange(languageId) {
        this.setState({languageId});
        ReactDOM.render(<div>&nbsp;</div>, document.getElementById("lexeme-navigator-page-container"));
    }

    _setRootEntryId(newState) {
        if (newState.length !== 0) {
            if (typeof this.props.isStandAlone !== 'undefined' && this.props.isStandAlone) {
                Dict.call('/page/getPage/' + newState.id + '/' + this.state.languageId + '/' + this.props.dictType).then(result => {
                    const StandAloneLexemePageConst = <LexemePageContent
                        key={"key-lexeme-read-move-sense-" + newState.id}
                        host={this.state.externalApi.host}
                        page={result.page} pageStatus={this.props.pageStatus}
                        classType={this.props.classType}
                        startItem={this.props.startItem}
                        status={'SET_PAGE'}
                        callBackSelectionHandler={(selectableItem) => this._callBackSelectionHandler(selectableItem)}/>;
                    ReactDOM.render(StandAloneLexemePageConst, document.getElementById(this.container));
                });
            } else {
                var dictType = null;
                if (this.props.pageStatus === LexemeEditingLevel.TRANSLATION_SELECTOR || this.props.pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE) {
                    dictType = 'TYPE_1_OUT';
                } else {
                    dictType = this.state.dictionaryType;//this.props.context.dictProperties.type;
                }

                Dict.call('/page/getPage/' + newState.id + '/' + this.state.languageId + '/' + dictType, undefined, typeof this.state.externalApi !== 'undefined' ? this.state.externalApi.host : undefined).then(result => {
                    const LexemePageConst = <LexemePageContent key={"key-lexeme-read-move-sense-" + newState.id}
                                                               page={result.page} pageStatus={this.props.pageStatus}
                                                               sharedOptions={result.sharedOptions}
                                                               host={typeof this.state.externalApi !== 'undefined' ? this.state.externalApi.host : undefined}
                                                               startItem={this.props.startItem}
                                                               textToAdd={this.props.textToAdd}
                                                               descrLanguage={result.descrLanguage/*JSON.parse(result.additionalInfos).descrLanguage*/}
                                                               status={'SET_PAGE'}
                                                               callBackSelectionHandler={(selectableItem) => this._callBackSelectionHandler(selectableItem)}/>;
                    ReactDOM.render(LexemePageConst, document.getElementById(this.container));
                    this.setState({rootEntryId: newState.id});
                });
            }
        } else {
            if (typeof this.props.callBackResetLexeme !== 'undefined')
                this.props.callBackResetLexeme();
            ReactDOM.render(<div/>, document.getElementById(this.container));
        }

        this._callBackSelectionHandler(newState);
    }

    _handleCreate() {
        Dict.call('/entry/createLexeme/' + this.state.searchOn.text + '/' + this.state.languageId + '/' + 'ENTRY' + '/', undefined, typeof this.state.externalApi !== 'undefined' ? this.state.externalApi.host : undefined).then((result) => {
            this._setRootEntryId({label: this.state.searchOn.text, id: result.id});
        });
    }

    _callBackSelectionHandler(selectableItem) {
        this.props.callbackParent(selectableItem, this.state.externalApi);
    }

    _handleOnFocus() {
        if (this.state.rootEntryId.length > 0)
            this.setState({rootEntryId: "", subEntryId: ""});
    }

    _getEntryTypeahead(preset) {
        return <EntryTypeahead key={"key-eth-navigator"} languageId={this.state.languageId}
                               host={typeof this.props.context.externalApi !== 'undefined' ? this.props.context.externalApi.host : undefined}
                               onFocus={this._handleOnFocus}
                               preset={preset}
                               useCache={Object.keys(this.state.navigatorChooseLangs).length === 1}
                               callbackParent={(newState) => this._setRootEntryId(newState)}
                               callbackParentSearchOn={(create, homographic, text) => {
                                   var searchOn = {create, homographic, text};
                                   this.setState({searchOn})
                               }}
        />
    }

    render() {
        const legend = "seleziona lemma"/* + Dict.t(this.props.pageStatus)*/;
        const isTranslator = this.props.pageStatus === LexemeEditingLevel.TRANSLATION_SELECTOR;
        const isReadOnlyCreate = this.props.pageStatus === LexemeEditingLevel.READ_ONLY_CREATE;
        const isReadOnlyExternalCreate = this.props.pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE;
        const isExternalDictionarySelector = this.props.pageStatus === LexemeEditingLevel.EXTERNAL_DICTIONARY_SELECTOR;

        var colCreate = '';
        var colTypeAhead = '';
        var colTransLangs = '';

        if (!isTranslator && !isReadOnlyCreate && !isReadOnlyExternalCreate) {
            colCreate = 0;
            colTypeAhead = 12;
            colTransLangs = 0;
        } else {
            if (isReadOnlyCreate) {
                colCreate = 3;
                colTypeAhead = 9;
                colTransLangs = 0;
            } else if (isReadOnlyExternalCreate) {
                colCreate = 5;
                colTypeAhead = 7;
                colTransLangs = 0;
            } else if (this.state.searchOn.homographic === true) {
                colCreate = 2;
                colTypeAhead = 6;
                colTransLangs = 4;
            } else {
                colCreate = 1;
                colTypeAhead = 5;
                colTransLangs = 6;
            }
        }

        var externalDropDown = '';
        var externalUrl = typeof this.state.externalApi !== 'undefined' ?
            <div
                className={stylesLexemeNavigator['external-api-url__div']}>{this.state.externalApi.name + ': ' + this.props.context.languageCode}</div> : '';
        var externalMessage = typeof this.state.externalApi !== 'undefined' && this.state.externalApi.status === 'error' ?
            <div
                className={BUtils.joinClasses(stylesLexemeNavigator['external-api-url__div'], stylesLexemeNavigator['external-api-error-message__div'])}>{this.state.externalApi.message}</div> : '';
        if (isExternalDictionarySelector) {
            var externalApis = Dict.getGlobalProperty('EXTERNAL_APIS');
            externalDropDown = <div className={stylesLexemeNavigator['external-api-url__dropdown']}>
                <DropdownButton
                    bsStyle={'Default'}
                    title={typeof this.state.externalApi === "undefined" ? 'Local' : this.state.externalApi.name}
                    key={'1111'}
                    id={'111p1'}>
                    {externalApis.split(';').map((result) => {
                        const split = result.split('|');
                        var externalApi = {};
                        externalApi.host = split[0];
                        externalApi.name = split[1];
                        return <MenuItem onClick={() => {
                            this.setState({externalApi}, () => {
                                Dict.call('/admin/options/getRootLanguages', undefined, externalApi.host).then((navigatorChooseLangs) => {
                                    this._resetNavigatoreChooseLangs(navigatorChooseLangs);
                                });
                            })
                        }}>{externalApi.name}</MenuItem>;
                    })}
                </DropdownButton>
            </div>;
        }

        return (
            <Grid
                className={BUtils.joinClasses(stylesLexemeNavigator['container-lexeme-navigator'], this.props.additionalContainerLexemeNavigatorClass)}
                textToAdd={this.props.textToAdd}
                textToTranslate={this.props.textToTranslate} fluid>
                {isReadOnlyExternalCreate ? <div
                    className={stylesLexemeNavigator['external-api-text-to-add']}>{this.props.textToAdd}</div> : ''}
                {isReadOnlyExternalCreate || isExternalDictionarySelector ?
                    <div className={stylesLexemeNavigator['external-api-container']}>
                        {externalDropDown}
                        {externalUrl}
                        {externalMessage}
                    </div> : ''}
                {!isReadOnlyExternalCreate || externalMessage.length === 0 ? <fieldset>
                    <legend>{legend}</legend>
                    <Col lg={colTypeAhead} md={colTypeAhead}>
                        <Row id={"row-entry-typeahead"}>{
                            this._getEntryTypeahead(this.state.searchOn.text)
                        }</Row>
                    </Col>
                    <Col lg={colCreate} md={colCreate} className={stylesLexemeNavigator['col-create-button']}>
                        {(isTranslator && this.state.searchOn.create) || isReadOnlyExternalCreate ?
                            <SCSubmitButton onClick={() => {
                                this._handleCreate();
                                this.props.callBackSave(this.state.searchOn.text);
                            }
                            }
                                            text={Dict.t(this.state.searchOn.homographic ? 'CREATE_HOMOGRAPHIC' : 'CREATE')}/>
                            : ''}
                        {isReadOnlyExternalCreate ? <Button onClick={() => {
                            var searchOn = this.state.searchOn;
                            searchOn.text = this.props.textToAdd;
                            ReactDOM.unmountComponentAtNode(document.getElementById('row-entry-typeahead'));
                            this.setState({
                                searchOn
                            }, () => {
                                var defaultTypeahead = this._getEntryTypeahead(searchOn.text);
                                ReactDOM.render(defaultTypeahead, document.getElementById('row-entry-typeahead'));

                            });
                        }}>aggiungi testo</Button> : ''}
                    </Col>
                    <Col lg={colTransLangs} md={colTransLangs}>{isTranslator /*|| isExternalDictionarySelector*/ ?
                        <SCRadiobutton
                            key={"key-radio-entry-sort-types-" + this.state.key}
                            bsStyle="default"
                            className="col-lg-4-35"
                            default={isTranslator ? this.state.navigatorChooseLangs[0].code + '' : this.state.navigatorChooseLangs.find((item) => {
                                return item.label === this.props.context.dictProperties.language_code;
                            }).code + ''}
                            items={this.state.navigatorChooseLangs}
                            callbackParent={(newState) => this._handleRadioTradChange(newState)}/> : ""}
                    </Col>
                </fieldset> : ''}
                <Grid id={this.container}
                      className={stylesLexemeNavigator['lexeme-navigator-page-container']} fluid/>
                {this.props.closeButton ? <div style={{textAlign: 'right', marginBottom: '10px'}}>
                    <Button onClick={() => {
                        this.props.callbackParentClose();
                    }}>{Dict.t('CLOSE')}</Button>
                </div> : ''}
            </Grid>

        );
    }
}





